"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.printObject = void 0;
var React = require("react");
exports.printObject = function (obj, className) {
    if (className === void 0) { className = "p-6 bg-grey-lightest text-xs"; }
    return (React.createElement("pre", { className: className },
        React.createElement("code", null, JSON.stringify(obj, null, 2))));
};
//# sourceMappingURL=print-object.js.map